import { animated, useSpring } from '@react-spring/web';
import { AlertCircle, X } from 'lucide-react';

interface Props {
  isVisible: boolean;
  title: string;
  message: string;
  onClose: () => void;
}

const ErrorAlertV2 = ({ isVisible, title, message, onClose }: Props) => {
  const { opacity, y } = useSpring({
    opacity: isVisible ? 1 : 0,
    y: isVisible ? 0 : -8,
    config: {
      tension: 260,
      friction: 22,
    },
  });

  if (!isVisible) return null;

  return (
    <animated.div
      style={{
        opacity,
        transform: y.to((v) => `translateY(${v}px)`),
      }}
      className="mb-6"
    >
      <div
        className="
          relative

          flex
          items-start
          gap-4

          rounded-xl

          border
          border-danger/30

          bg-danger/10

          p-5

          shadow-card

          dark:border-danger/20
          dark:bg-danger/10
        "
      >
        {/* Línea lateral */}
        <div
          className="
            absolute
            left-0
            top-0

            h-full
            w-1

            rounded-l-xl

            bg-danger
          "
        />

        {/* Icono */}
        <div
          className="
            flex
            h-10
            w-10
            flex-none
            items-center
            justify-center

            rounded-lg

            bg-danger

            text-white
          "
        >
          <AlertCircle className="h-5 w-5" />
        </div>

        {/* Contenido */}
        <div className="min-w-0 flex-1">
          <h4
            className="
              text-base
              font-semibold

              text-black
              dark:text-white
            "
          >
            {title}
          </h4>

          <p
            className="
              mt-1

              text-sm

              text-body
              dark:text-bodydark
            "
          >
            {message}
          </p>
        </div>

        {/* Cerrar */}
        <button
          onClick={onClose}
          className="
            rounded-lg

            p-1.5

            text-bodydark2

            transition-all
            duration-200

            hover:bg-danger/10
            hover:text-danger
          "
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </animated.div>
  );
};

export default ErrorAlertV2;
